<template>
    <section class="tabbed_content fluid_tabs cf">
        <div v-html="instantWin"></div>
    </section>
</template>

<script>
    import $ from 'jquery';
    import moment from "moment";
import { inject } from 'vue';

    export default {
        data: function () {
            return {
                mobileCashing: false,
                token: '',
                instantWin: '',
                message: '',
                image: ''
            }
        },
        mounted: function () {
            this.getToken();
        },
        methods: {
            getToken() {
                this.getAPItoken()
                .then((token) => {
                    this.token = token;
                    this.getTerms();
                });
            },
            getTerms() {
                let apiToken = this.token,
                    sku = this.getURLQuery('orderId'),
                    url = process.env.VUE_APP_APIURL + '/1.0/Games/StaticContentElements/StaticContentElement/GetContentElementByKey?contentKey=mlr-instant-win';

                return fetch(url, {
                        method: 'GET',
                        // body: JSON.stringify(datCreds),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + apiToken,
                        },
                    }
                )
                .then((response) => response.json())
                .then((json) => {
                    this.instantWin = json.data[0].centralContent;
                    let button = document.getElementById('closeTC');
                    
                    this.getMessage();
                })
                .catch((error) => {
                    // console.error("There was an error!", error);
                    return (this.errorMessage = error);
                });
            },
            getMessage() {
                let winner = JSON.parse( sessionStorage.getItem('apiToken')),
                    message = winner.notifications[0].message,
                    image = winner.notifications[0].imageURL;

                let injectMessage = document.getElementById('iwMessage'),
                    injectImage = document.getElementById('iwImage');

                injectMessage.innerText = message;
                injectImage.src = image;
            }
		}
    };
</script>

<style scss-scoped>
    /* #TransactionLogPage {
        height: 240px;
        margin: 15px 0;
        overflow-y: scroll;
    } */
</style>